import axios from '../api/axios';

export async function getCarHouseUsers(carHouseId, pagination, options) {
  const headers = {
    page: pagination.page,
    limit: pagination.total,
  };

  options['headers'] = headers;

  const res = await axios.get(`/carHouses/${carHouseId}/users`, options);
  const data = {
    users: res.data.results,
    count: res.data.count,
  };
  return data;
}

export async function getCarHouseUserById(carHouseId, userId) {

  const res = await axios.get(`/carHouses/${carHouseId}/users/${userId}`);

  return res;
}

export async function createCarHouseUser(carHouseId, body) {
  const res = await axios.post(
    `/carHouses/${carHouseId}/users`,
    JSON.stringify(body),
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  return res.data;
}

export async function updateCarHouseUser(carHouseId, userId, body) {
  const res = await axios.patch(
    `/carHouses/${carHouseId}/users/${userId}`,
    JSON.stringify(body),
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  return res.data;
}

export async function deleteCarHouseUser(carHouseId, userId) {
  const res = await axios.delete(`/carHouses/${carHouseId}/users/${userId}`);

  return res.data;
}


export async function assignLogoToUser(userId, logoId) {
  const response = await axios.post(`/users/${userId}/logos/${logoId}`);

  return response.data;
}